import {UrlTree} from '@angular/router';

export class RouterHelper {
  public static isAngular2Url = (url: string|UrlTree) => url.toString().startsWith('/n/');
}
